import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRouterConfiguration } from "@/shared/interfaces/setting";

export interface FreightOptionSummary {
  externalId: number;
  name: string;
  isActive: boolean;
}

export interface PlanCustomer {
  customerAddressId: number;
  customerName: string;
  street: string;
  city: string;
  latitude: number;
  longitude: number;
  hasCurrentOrder: boolean;
  customerExternalId: string;
  shippingAddressExternalId: string;
  lastSequence: number;
  freightOptions: FreightOptionSummary[];
}

export interface OptimiseRoutesState {
  loading: boolean;
  routeConfigs: IRouterConfiguration[];
  planCustomers: PlanCustomer[];
  emailLoading: boolean;
}

const initialState: OptimiseRoutesState = {
  loading: false,
  routeConfigs: [],
  planCustomers: [],
  emailLoading: false,
};

const optimiseRoutesSlice = createSlice({
  name: "optimise-routes",
  initialState,
  reducers: {
    reset: () => initialState,
    getRouteConfigs: (state, _action: PayloadAction<number>) => {
      state.loading = true;
      state.routeConfigs = [];
      state.planCustomers = [];
    },
    getRouteConfigsSuccess: (state, action: PayloadAction<IRouterConfiguration[]>) => {
      state.loading = false;
      state.routeConfigs = action.payload;
    },
    getPlanTemplate: (state, _action: PayloadAction<number>) => {
      state.loading = true;
      state.planCustomers = [];
    },
    getPlanTemplateSuccess: (state, action: PayloadAction<PlanCustomer[]>) => {
      state.loading = false;
      state.planCustomers = action.payload;
    },
    sendEmail: (state, _action: PayloadAction<{ to: string; routeName: string; csvContent: string }>) => {
      state.emailLoading = true;
    },
    sendEmailSuccess: (state) => {
      state.emailLoading = false;
    },
    requestFailed: (state) => {
      state.loading = false;
      state.emailLoading = false;
    },
  },
});

export const optimiseRoutesActions = optimiseRoutesSlice.actions;

export default optimiseRoutesSlice.reducer;
